import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-message-prompt"
};
const _hoisted_2 = {
  class: "chat-item"
};
const _hoisted_3 = ["data-clipboard-text", "innerHTML"];
const _hoisted_4 = {
  class: "chat-icon"
};
import { onMounted, ref } from "vue";
import Clipboard from "clipboard";
import { showNotify } from "vant";

// eslint-disable-next-line no-unused-vars,no-undef

export default {
  __name: 'ChatPrompt',
  props: {
    content: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: '/images/user-icon.png'
    }
  },
  setup(__props) {
    const props = __props;
    const contentRef = ref(null);
    onMounted(() => {
      const clipboard = new Clipboard(contentRef.value);
      clipboard.on('success', () => {
        showNotify({
          type: 'success',
          message: '复制成功',
          duration: 1000
        });
      });
      clipboard.on('error', () => {
        showNotify({
          type: 'danger',
          message: '复制失败',
          duration: 2000
        });
      });
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        ref_key: "contentRef",
        ref: contentRef,
        "data-clipboard-text": __props.content,
        class: "content",
        innerHTML: __props.content
      }, null, 8, _hoisted_3), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "triangle"
      }, null, -1))]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
        src: __props.icon
      }, null, 8, ["src"])])]);
    };
  }
};